import React, {useState, useEffect} from 'react'
import {Layout, Menu} from 'antd';
import {Link, withRouter} from 'react-router-dom';
import { getUserInfo } from '@/common/api/user';
import {listConvertTree, sortDataByKey} from '@/common/js/utils';
import IconFont from '@/components/iconFont'
import config from '@/config/index'
const { Sider } = Layout;
const { SubMenu } = Menu;
import log from '@/common/images/headerLogo.png'

function Sidebar(props) {
    const [collapsed, statCollapsed] = useState(false)
    const [menuDomList, setMenuDom] = useState([])
    const rank = props.location.pathname.split('/')
    const [defaultOpen] = useState(() => {
        switch (rank.length) {
            case 3:
                return [rank.slice(0, 2).join('/')]
            case 4:
                return [rank.slice(0, 2).join('/'), rank.slice(0, 3).join('/')]
            default:
                break;
        }
    })
    let menuDom = [];
    const onCollapse = () => {
        statCollapsed(!collapsed)
    }
    /**
     * function getMenuDomList
     * 生成菜单dom列表方法
     */
    function getMenuDomList(data) {
        return data.map(item => {
            if (item.menuCode && item.menuCode.indexOf('APP_') === -1 && item.children && item.children.length > 0) {
                return (
                    <SubMenu icon={<IconFont className="layout_icon" type={item.icon}/>}
                        key={item.path}
                        title={item.menuName}
                    >
                        {getMenuDomList(item.children)}
                    </SubMenu>
                )
            } else if(item.menuCode && item.menuCode.indexOf('APP_') === -1){
                return (
                    <Menu.Item icon={<IconFont className="layout_icon" type={item.icon}/>}
                        key={item.path}
                    >
                        <Link to={item.path}>{item.menuName}</Link>
                    </Menu.Item>
                )
            }
        })
    }
    /**
     * function handleUserInfo
     * 获取用户信息并生成dom树
     */
    function handleUserInfo() {
            getUserInfo().then(res => {
                if (res.code === 0 && res.data.menuList.length > 0 ) {
                    const opt = {
                        primaryKey: 'id',
                        parentKey: 'parentId',
                        startPid: '-1'
                    }
                    res.data.menuList.map(item => {
                        item.key = item.path
                        item.value = item.id
                        item.label = item.menuName
                        return item
                    })
                    res.data.menuList = sortDataByKey(res.data.menuList,'priority','asc')
                    const data =  listConvertTree(res.data.menuList, opt)
                    if (config.pubshAdd === 'tj') {
                        menuDom = getMenuDomList(data)
                    } else {
                        data.some((item, index) => {
                            if (item.key === '/home') {
                                data.splice(index, 1)

                            }
                        })
                        menuDom = getMenuDomList(data)
                    }
                    setMenuDom(menuDom)
                    localStorage.setItem('userInfo',JSON.stringify(res.data))
                }
            })
    }
    useEffect(() => {
        handleUserInfo()
    },[])
    return (
            <Sider
                collapsed={collapsed}
                collapsible
                onCollapse={onCollapse}
            >
                <div className="logo">
                    <p className="logo-name"><img width={155} height={55} src={log}></img></p>
                </div>
                <Menu
                    defaultOpenKeys={defaultOpen}
                    defaultSelectedKeys={[props.location.pathname]}
                    mode="inline"
                    theme="dark"
                >
                    {menuDomList}
                </Menu>
            </Sider>
    )
}
export default withRouter(Sidebar)
